module.exports = __webpack_public_path__ + "assets/img/70x_519.27ad1c34.jpg";